import React from 'react';
import { services } from '../mockData';

export const ServicesSectionNew = () => {
  return (
    <section id="services" className="py-[140px] px-10 sm:px-20 bg-gradient-to-b from-[#FAFBFC] to-white">
      <div className="max-w-[1600px] mx-auto">
        {/* Section Header */}
        <div className="max-w-[680px] mx-auto text-center mb-[88px]">
          <div className="inline-flex items-center gap-[10px] text-[13px] font-bold text-[#7CB342] tracking-[0.1em] uppercase mb-6">
            <span className="w-10 h-[2px] bg-gradient-to-r from-[#006B3F] to-[#7CB342]" />
            Unsere Leistungen
            <span className="w-10 h-[2px] bg-gradient-to-r from-[#006B3F] to-[#7CB342]" />
          </div>
          <h2 className="text-[58px] font-[900] leading-[1.15] tracking-[-0.03em] text-[#0D0D0D] mb-7">
            Alles rund um Ihre Fahrzeugzulassung
          </h2>
          <p className="text-[19px] leading-[1.7] text-[#5A5A5A]">
            Von der Neuzulassung bis zur Ummeldung – wir kümmern uns um alle behördlichen Angelegenheiten.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="group bg-white p-[44px] rounded-[20px] border border-[#006B3F]/[0.08] transition-all duration-[400ms] hover:translate-y-[-12px] hover:shadow-[0_28px_70px_rgba(0,0,0,0.12)] hover:border-[#006B3F]/[0.16] relative overflow-hidden"
            >
              {/* Top Border Animation */}
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#006B3F] to-[#7CB342] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-[400ms]" />
              
              {/* Icon */}
              <div className="w-16 h-16 bg-gradient-to-br from-[#006B3F]/[0.08] to-[#7CB342]/[0.08] rounded-2xl flex items-center justify-center text-[32px] mb-7">
                {service.icon === 'Zap' ? '⚡' : 
                 service.icon === 'FileCheck' ? '🚗' :
                 service.icon === 'RefreshCw' ? '🔄' :
                 service.icon === 'FileX' ? '📋' :
                 service.icon === 'Wifi' ? '🌐' :
                 service.icon === 'Star' ? '⭐' :
                 service.icon === 'Tag' ? '🏷️' :
                 service.icon === 'Search' ? '🔍' :
                 service.icon === 'Shield' ? '🛡️' : '📄'}
              </div>

              {/* Title */}
              <h3 className="text-[22px] font-[800] text-[#0D0D0D] mb-[14px] tracking-[-0.02em]">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-[15px] leading-[1.7] text-[#5A5A5A] mb-7">
                {service.description}
              </p>

              {/* Price */}
              <div className="text-[36px] font-[900] bg-gradient-to-r from-[#006B3F] to-[#7CB342] bg-clip-text text-transparent tracking-[-0.02em]">
                {service.price}
              </div>
            </div>
          ))}
        </div>

        {/* Info Note */}
        <div className="mt-12 text-center">
          <p className="text-[15px] text-[#5A5A5A] mb-2">
            Alle Preise inkl. Bearbeitungsgebühren – keine versteckten Kosten
          </p>
          <p className="text-[14px] text-[#7A7A7A]">
            * Kennzeichen-Erstellung gegen Aufpreis möglich, falls Sie keine eigenen Kennzeichen mitbringen
          </p>
        </div>
      </div>
    </section>
  );
};